import React from "react";
import PropTypes from "prop-types";
import {
  DataTable,
  NoteTooltipTableCell,
  PartNumber
} from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import { CONDITION_TYPES } from "MODULES/Receiving/constants";
import LocationFlag from "MODULES/shared/components/LocationFlag/LocationFlag";
import { Link } from "react-router-dom";
import StatusTags from "MODULES/Receiving/components/shared/StatusTags";
import { decorators, Paginator } from "@orange-marmalade/paginate-this";

function Row({ record, statuses }) {
  return (
    <tr className="clickable">
      <td>
        <Link
          onClick={e => e.stopPropagation()}
          to={`/receiving/${record.uuid}`}
        >
          {record.code}
        </Link>
      </td>
      <td>{shortDate(record.created_at)}</td>
      <td>
        <PartNumber part={record.part} />
      </td>
      <td>
        {record.inventories.length > 0 ? (
          <Link
            onClick={e => e.stopPropagation()}
            to={`/inventories/${record.inventories[0].uuid}`}
          >
            {record.serial_number}
          </Link>
        ) : (
          record.serial_number
        )}
      </td>
      <td>
        <LocationFlag location={record.store_location_id} />
      </td>
      <td>{CONDITION_TYPES[record.condition].label}</td>
      <td className="text-center">{record.quantity}</td>
      <td>{record.awb_number}</td>
      <td>
        <StatusTags {...statuses} />
      </td>
      <NoteTooltipTableCell note={record.minor_note} />
    </tr>
  );
}

Row.propTypes = {
  record: PropTypes.shape({}),
  statuses: PropTypes.shape({})
};

export function Table({ results, isLoading }) {
  return [
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>REC #</th>
        <th>REC Date</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Store Loc</th>
        <th>COND Rec</th>
        <th className="text-center">QTY Rec</th>
        <th>AWB #</th>
        <th>Status</th>
        <th>Minor Notes</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(record => <Row key={record.id} record={record} />)}
      </DataTable.Body>
    </DataTable>,
    <nav
      className="text-center margin-top-none"
      aria-label="Search results pages"
    >
      <Paginator listId="purchaseOrders/receivingRecords" />
    </nav>
  ];
}

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired
};

const ConnectedTable = decorators.tabulate(Table);

export default props => (
  <ConnectedTable listId="purchaseOrders/receivingRecords" {...props} />
);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/ReceivingRecordsTable/ReceivingRecordsTable.jsx